import { Api } from "../config/request";

export default {
  getGenSetting() {
    return Api.get("/config/gen-setting");
  },
  getFormSchema() {
    return Api.get("/config/form-schema");
  },
  updateGenSetting(payload) {
    return Api.put("/config/gen-setting/update", payload);
  },
  getFinalConfig(payload) {
    return Api.post("/config/final-config", payload);
  },
  getLevel(payload) {
    return Api.post("/config/level", payload);
  },
  getGenSettingChangeLog(queryParams) {
    return Api.get(
      `/config/gen-setting/change-logs${
        queryParams && queryParams.length > 0 ? `${queryParams}` : ""
      }`
    );
  },
  getGenSettingKeys(queryParams) {
    return Api.get(
      `/config/gen-setting/keys${
        queryParams && queryParams.length > 0 ? `${queryParams}` : ""
      }`
    );
  },
};
